import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Container, Tab } from '@mui/material';
import React, { useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { GuardedRoute } from 'react-router-guards';

import { NotFound } from 'app/components/not-found';
import { Role } from 'app/constants/role';

import { BrandRouter } from './brands/brand-router';
import { BrandSearch } from './brands/brand-search';
import { CategoryRouter } from './categories/category-router';
import { CleanPatternsRouter } from './clean-patterns/clean-patterns-router';
import { CrisHeader } from './cris-header';
import { CrisRequestForm } from './cris-request-form';
import { Kanban } from './kanban';
import { CrisRequestListing } from './listing/cris-request-listing';
import { MccRouter } from './mccs/mcc-router';
import { PartnerMapRouter } from './partner-map/partner-map-router';
import { CrisPartnerRouter } from './partners/cris-partner-router';
import { CrisPartnerSearch } from './partners/cris-partner-search';
import { RemovalQueueListing } from './removal-queue/removal-queue-listing';
import { CrisRequestRouter } from './request/cris-request-router';
import { StoreSearch } from './stores/store-search';
import { StoresRouter } from './stores/stores-router';
import { Taxonomy } from './taxonomy';
import { ThresholdsRouter } from './thresholds/thresholds-router';

/**
 * A router for CRIS subsection
 */
export const CrisRouter: React.FunctionComponent = () => {
    const [value, setValue] = useState('1');

    return (
        <Switch>
            <Route path='/cris/request'>
                <Container maxWidth={false} className='mt-3'>
                    <Switch>
                        <Route path='/cris/request/new'>
                            <TabContext value={value}>
                                <TabList onChange={(evt, tab: string) => setValue(tab)}>
                                    <Tab label='Single' value='1' />
                                    <Tab label='Batch' value='2' />
                                </TabList>
                                <TabPanel value='1'>
                                    <CrisRequestForm />
                                </TabPanel>
                                <TabPanel value='2'>
                                    <p>Coming Soon</p>
                                </TabPanel>
                            </TabContext>
                        </Route>
                        <GuardedRoute path='/cris/request/:id' meta={{ role: 'ROLE_USER' }}>
                            <CrisRequestRouter />
                        </GuardedRoute>
                    </Switch>
                </Container>
            </Route>
            <Route path='*'>
                <CrisHeader />
                <Container maxWidth={false} className='py-3 remaining-height'>
                    <Switch>
                        <Route exact path='/cris'>
                            <Redirect to='/cris/list' />
                        </Route>
                        <GuardedRoute path='/cris/list' meta={{ role: 'ROLE_USER' }}>
                            <CrisRequestListing />
                        </GuardedRoute>
                        <GuardedRoute path='/cris/kanban' meta={{ role: 'ROLE_USER' }}>
                            <Kanban />
                        </GuardedRoute>
                        <GuardedRoute path='/cris/taxonomy' meta={{ role: 'ROLE_USER' }}>
                            <Taxonomy />
                        </GuardedRoute>
                        <GuardedRoute exact path='/cris/brands' meta={{ role: 'ROLE_USER' }}>
                            <BrandSearch />
                        </GuardedRoute>
                        <GuardedRoute path='/cris/categories' meta={{ role: Role.TAXONOMY_ADMIN }}>
                            <CategoryRouter />
                        </GuardedRoute>
                        <GuardedRoute path='/cris/mccs' meta={{ role: Role.TAXONOMY_ADMIN }}>
                            <MccRouter />
                        </GuardedRoute>
                        <GuardedRoute path='/cris/brands/:id' meta={{ role: 'ROLE_USER' }}>
                            <BrandRouter />
                        </GuardedRoute>
                        <GuardedRoute exact path='/cris/stores' meta={{ role: 'ROLE_USER' }}>
                            <StoreSearch />
                        </GuardedRoute>
                        <GuardedRoute path='/cris/stores/:id' meta={{ role: 'ROLE_USER' }}>
                            <StoresRouter />
                        </GuardedRoute>
                        <GuardedRoute exact path='/cris/partners' meta={{ role: Role.CRIS_USER }}>
                            <CrisPartnerSearch />
                        </GuardedRoute>
                        <GuardedRoute exact path='/cris/partners/:id' meta={{ role: Role.CRIS_USER }}>
                            <CrisPartnerRouter />
                        </GuardedRoute>
                        <GuardedRoute path='/cris/partner-maps' meta={{ role: Role.ADMIN }}>
                            <PartnerMapRouter />
                        </GuardedRoute>
                        <GuardedRoute path='/cris/removal-queue' meta={{ role: Role.TAXONOMY_ADMIN }}>
                            <RemovalQueueListing />
                        </GuardedRoute>
                        <GuardedRoute path='/cris/clean-patterns' meta={{ role: Role.SEAM_PROCESS_ADMIN }}>
                            <CleanPatternsRouter />
                        </GuardedRoute>
                        <GuardedRoute path='/cris/thresholds' meta={{ role: Role.SEAM_PROCESS_ADMIN }}>
                            <ThresholdsRouter />
                        </GuardedRoute>
                        <Route path='*'>
                            <NotFound />
                        </Route>
                    </Switch>
                </Container>
            </Route>
        </Switch>
    );
};
